import { ACCOUNT, apiClient, SUBSCRIPTION_CANCELLATION } from '../../../shared/api';

export const cancelSubscription = async () => {
  const response = await apiClient.post(SUBSCRIPTION_CANCELLATION);

  return response.data;
};

export const fetchAccount = async () => {
  const response = await apiClient.get(ACCOUNT);

  return response.data;
};

export const resumeSubscription = async () => {
  const response = await apiClient.delete(SUBSCRIPTION_CANCELLATION);

  return response.data;
};
